export default "/images/c4d3da4d8b1c6b92718675a3f12c77f7.avif";